import { render, staticRenderFns } from "./PromotionsHeader.vue?vue&type=template&id=ddd679d2&scoped=true"
import script from "./PromotionsHeader.vue?vue&type=script&lang=ts"
export * from "./PromotionsHeader.vue?vue&type=script&lang=ts"
import style0 from "./PromotionsHeader.vue?vue&type=style&index=0&id=ddd679d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd679d2",
  null
  
)

export default component.exports